<template>
  <section v-if="mobile">
    <div ref="trace"></div>

    <div class="navbar">
      <MobileNavBarButtons />
    </div>

    <div v-if="stickBar" class="navbar sticky">
      <MobileNavBarButtons />
    </div>
  </section>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useElementBounding } from '@vueuse/core'
import MobileNavBarButtons from '@/modules/Itinerary/Components/MobileNavBarButtons.vue'
import { useShared } from '@/helpers/vueHelpers.js'

const trace = ref()
const { mobile } = useShared()
const { bottom } = useElementBounding(trace)
const stickBar = computed(() => bottom.value < 0)
</script>

<style lang="scss" scoped>
section {
  @include main-unwrap;
  margin-top: -24px;
}

.navbar {
  max-width: 100vw;
  display: flex;
  padding-inline: 24px;
  overflow-x: auto;
  border-bottom: 1px solid $grey-50;
  gap: 16px;
  @include hide-scrollbar;
}

.navbar.sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 1000;
}
</style>

<style lang="scss">
.site-header--docked,
.site-header--floating {
  .navbar.sticky {
    top: var(--site-header-height);
  }
}
</style>
